import React from "react";
import AdminLayout from "../adminpanel/AdminLayout";

export default function AdminPanel() {
  return (
    <AdminLayout>
      <h1 style={{ marginTop: 0 }}>Admin • Översikt</h1>
      <p>Välj en sida i menyn till vänster.</p>
    </AdminLayout>
  );
}




